module.exports = __webpack_public_path__ + "img/img17.9d950e50.jpg";